module.exports = __webpack_public_path__ + "img/youtube.8fd930d3.svg";